import React from 'react'
import PropTypes from 'prop-types'
import FormX from 'sb-formx'
import actions from 'redux/actions'
import { useState, useMedia, useCallback } from 'sb-hooks'
import { constants, snowplow } from 'common/helpers'
import { email, required } from 'helpers/validation'

import Mobile from './Mobile/Mobile'
import ExceptMobile from './ExceptMobile/ExceptMobile'

import messages from './messages'


const form = new FormX({
  fields: {
    email: [ required, email ],
  },
})

const getUniqueId = ((id) => () => String(++id))(1)

const InviteForm = ({ page }) => {
  const { isMobile } = useMedia()
  const [ isFetching, setFetching ] = useState(false)

  const trackAnalytics = useCallback(() => {
    snowplow.track(constants.snowplowEvents.shareButtonClick, {
      type: 'email',
      page,
    })
  }, [ page ])

  const handleSubmit = useCallback((event) => {
    event.preventDefault()

    form.submit()
      .then(({ email }) => {
        setFetching(true)

        trackAnalytics()

        Promise.all([
          actions.models.me.stopInviteTracking(),
          actions.models.me.inviteUser([ email ]),
        ])
          .then(() => {
            actions.models.modals.open(constants.modals.Dialog, {
              contentMessage: messages.modalTitle,
              buttonTitle: messages.modalButtonTitle,
            })

            form.unsetValues()
          })
          .finally(() => setFetching(false))
      })
  }, [])

  const inputId = `email${getUniqueId()}`

  return React.createElement(isMobile ? Mobile : ExceptMobile, {
    field: form.fields.email,
    placeholder: messages.placeholder,
    buttonTitle: messages.buttonTitle,
    loading: isFetching,
    onSubmit: handleSubmit,
    inputId,
  })
}

InviteForm.propTypes = {
  page: PropTypes.string.isRequired,
}


export default InviteForm
